module.exports = __webpack_public_path__ + "static/media/research_1.322eb6a3.png";